import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Questionnaire from '../../containers/Voting';
import StartPage from '../StartPage';
import './index.scss';
import Election from '../../containers/Election';

class Dashboard extends Component {
  render() {
    return (
      <div className="Dashboard">
        <Switch>
          <Route path="/" exact component={StartPage} />
          <Route path="/voting/:id" component={Questionnaire} />
          <Route path="/election/:id" component={Election} />
          <Route render={() => <Redirect to={'/'} />} />
        </Switch>
      </div>
    );
  }
}

export default Dashboard;
